import type { ReactElement } from 'react'
import { useFormState } from 'react-hook-form'
import { Box } from '@mui/material'
import { Tabs as DetailTabs } from '@ui/navigation'
import { useSnackbar } from '@ui/snackbar'
import Results2DetailCloseButton from '../../Results2DetailCloseButton'
import { UNSAVED_BEMESSUNG_NAV_MESSAGE, unsavedBemessungNavSnackbarOptions } from '../constants'
import type { DesignFormRootValues, DetailPaneTabId } from '../types'

export const GuardedResults2DetailTabs = ({
  tab,
  setTab,
  documentCount,
  surfaceTabLabel,
}: {
  tab: DetailPaneTabId
  setTab: (t: DetailPaneTabId) => void
  documentCount: number
  /** Label for the merged Dach/Decke surface tab; omit to hide it (non-slab-beam elements). */
  surfaceTabLabel?: string
}): ReactElement => {
  // Use `dirtyFields` (not `formState.isDirty`) as the dirtiness source of truth, matching
  // BottomActionBar and the design-form guard: "Rückgängig" resets with `keepDirty: false`, which
  // clears `dirtyFields` but can leave `formState.isDirty` stuck true.
  const { dirtyFields } = useFormState<DesignFormRootValues>()
  const isDirty = Object.keys(dirtyFields).length > 0
  const { enqueueSnackbar } = useSnackbar()
  return (
    <Box sx={{ flexShrink: 0, position: 'relative' }}>
      <DetailTabs
        items={[
          { id: 'design', label: 'Bemessung' },
          ...(surfaceTabLabel ? [{ id: 'surface', label: surfaceTabLabel }] : []),
          { id: 'vertical-connections', label: 'Vertikale Verbindungen' },
          { id: 'documents', label: `Dokumente (${documentCount})` },
        ]}
        value={tab}
        onChange={id => {
          const next = id as DetailPaneTabId
          if (next !== tab && isDirty) {
            enqueueSnackbar(UNSAVED_BEMESSUNG_NAV_MESSAGE, unsavedBemessungNavSnackbarOptions)
            return
          }
          setTab(next)
        }}
        size="md"
        kind="folder"
      />
      <Results2DetailCloseButton disabled={isDirty} />
    </Box>
  )
}
